import styles from './Spinner.module.css';

export type SpinnerProps = {
  className?: string;
};

export const Spinner = ({ className }: SpinnerProps) => <div className={`${styles.spinner} ${className || ''}`} />;
